import { UsuariosComponent } from './usuarios.component';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { PrincipalLayoutComponent } from '../../layout/principal-layout/principal-layout.component';
import { AuthGuardService } from 'src/app/services/auth-guard.service';

const routes: Routes = [
  {
    path: 'usuarios',
    component: PrincipalLayoutComponent,
    // canActivate: [AuthGuardService],
    children: [
      { path: '', component: UsuariosComponent },
    ]
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class UsuariosRoutingModule { }
